import React from 'react';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const AJAX_URL = window.wpApiSettings.fiq_ajax_url;

class SiteAdmins extends React.Component {
	constructor(props) {
		super();

		this.state = {
			saved_success: false,
			saved_error: false,
			user: props.user
		};

		this.saveOptions = this.saveOptions.bind(this);
		this.saveSiteAdmin = this.saveSiteAdmin.bind(this);
		this.changeOptions = this.changeOptions.bind(this);
	}

	saveOptions(user) {
		fetch(AJAX_URL, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
			body: 'action=fiq_save_options&data=' + JSON.stringify(user),
			credentials: 'same-origin'
		}).then(data => {
			if (data.ok) {
				this.setState({ saved_success: true });
				setTimeout(() => {
					this.setState({ saved_success: false });
				}, 2500);
			} else {
				this.setState({ saved_error: true });
				setTimeout(() => {
					this.setState({ saved_error: false });
				}, 2500);
			}
		});
	}

	saveSiteAdmin(event, user) {
		if (event) { event.preventDefault(); }
		this.props.onSelectSiteAdmin(user);
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, 'action', 'email_siteadmin');
			this.saveOptions(user);
			return { user };
		});
	}

	changeOptions(event) {
		var { target: { name, value } } = event;
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, name, value);
			return { user };
		});
	}

	render() {
		const assigned_users = this.state.user.inspectors;
		return (
			<form className={'user_' + this.state.user.id} onSubmit={(e) => this.saveSiteAdmin(e, this.state.user)}>
				<div>
					<Tabs defaultIndex={0} className="react-tabs fiq-user-tabs">
						<TabList className='react-tabs__tab-list'>
							<Tab>Profile</Tab>
						</TabList>
						<TabPanel>
							<div className="fields">
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Company Name</strong></label></div>
									<div className='input iconField'><input name='company' type='text' value={this.state.user.company} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-portfolio"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Address</strong></label></div>
									<div className='input iconField'><input name='address' type='text' value={this.state.user.address} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-admin-home"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>City</strong></label></div>
									<div className='input iconField'><input name='city' type='text' value={this.state.user.city} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-building"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>State</strong></label></div>
									<div className='input iconField'><input name='state' type='text' value={this.state.user.state} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-bank"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Zip Code</strong></label></div>
									<div className='input iconField'><input name='zip' type='text' value={this.state.user.zip} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-location"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Phone Number</strong></label></div>
									<div className='input iconField'><input name='phone' type='text' value={this.state.user.phone} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-phone"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Email Address</strong></label></div>
									<div className='input iconField'><input name='user_email' type='text' value={this.state.user.user_email} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-email"></i></div>
								</div>
								<input type='submit' value='Save Changes' className='button button-primary' />
								<span className={this.state.saved_success ? 'msg-success saved' : 'msg-success'}><i className={'dashicons dashicons-yes-alt'}></i> Success: User information saved successfully</span>
								<span className={this.state.saved_error ? 'msg-failed error' : 'msg-failed'}><i className={'dashicons dashicons-warning'}></i> Error: There was an error saving your changes</span>
							</div>
						</TabPanel>
					</Tabs>
				</div>
			</form >
		);
	}
}

export default SiteAdmins;